module.exports = __webpack_public_path__ + "static/media/Sharp-LQ104V1DG81-Tech-Drawing.71107586.png";